export default "__VITE_ASSET__HiVymPhi__"